<app-lfsa-card [innTemplate]="enviarTemplate" [titulo]="tituloCard" *ngIf="!mostrarFormulario" [optionsExport]="false">
</app-lfsa-card>

<ng-template #enviarTemplate>
  <h2 class="container float-left">{{ tituloForm }}</h2>
  <div [formGroup]="buscador" novalidate class="form-group">
    <div class="row">
      <div class="col-md-4">
        <app-lfsa-input [type]="'number'" [class]="'letrasDanger'" [placeholder]="'Año'" [label]="'Año *'" [id]="'anio'"
          formControlName="anio" [control]="buscador.get('anio')"></app-lfsa-input>
      </div>
      <div [class]="'col-md-3'">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'valor'" [idOpcion]="'clave'" [comboBox]="cmbPeriodo"
          formControlName="desde" [control]="buscador.get('desde')" [label]="'Desde*'" [id]="'desde'">
        </app-lfsa-combo-box>
      </div>
      <div [class]="'col-md-3'">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'valor'" [idOpcion]="'clave'" [comboBox]="cmbPeriodo"
          formControlName="hasta" [control]="buscador.get('hasta')" [label]="'Hasta*'" [id]="'hasta'">
        </app-lfsa-combo-box>
      </div>
      <div class="col-md-4">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'dscaOficinaVenta'" [idOpcion]="'idOficinaVenta'"
            [comboBox]="listaDeAgencias" formControlName="agencia" [control]="buscador.get('agencia')"
            [label]="'Agencia *'" [id]="'agencia'">
          </app-lfsa-combo-box>
      </div>
      <div class="col-md-4">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [opcion]="'nombre'" [idOpcion]="'id'"
            [comboBox]="listaDeVersiones" formControlName="version" [control]="buscador.get('version')"
            [label]="'Versión *'" [id]="'version'">
          </app-lfsa-combo-box>
      </div>
      <div class="col-md-4" style="float: right;">
        <button (click)="buscar()" class="mt-4 {{DAT_BTNCSS.success}}">Buscar</button>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <ag-grid-angular class="{{modulo.agGrid.class}}" #agGrid [ngStyle]="modulo.agGrid.style" id="{{modulo.agGrid.id}}"
        [paginationPageSize] = "modulo.agGrid.paginacion" [pagination]="true"
        [frameworkComponents]="frameworkComponents" [columnDefs]="columnDefs" [rowSelection]="rowSelection"
        [rowData]="rowData" (gridReady)="onGridReady($event)">
      </ag-grid-angular>
    </div>
  </div>
</ng-template>

<app-lfsa-modal [innTemplate]="enviarModal" [titulo]="'Editar Modelo de Negocio'" [idButton]="'buttonAbrirModal'"
  [idOpen]="'abrirModal'" [idClose]="'cerrarModal'"></app-lfsa-modal>
<ng-template #enviarModal>
  <div [formGroup]="formulario" novalidate class="form-group">
    <div class="row">
      <div class="row">
        <div class="form-group col-12 col-md-3">
          <app-lfsa-input [isReadOnly]="true" [type]="'text'" [class]="'letrasDanger'" [placeholder]="'Ingrese fecha de registro'"
            [label]="'Fecha de registro *'" [id]="'fecha_registro'" formControlName="fecha_registro" [control]="formulario.get('fecha_registro')"></app-lfsa-input>
        </div>
        <div class="form-group col-12 col-md-3">
          <app-lfsa-input [isReadOnly]="true" [type]="'text'" [class]="'letrasDanger'" [placeholder]="'Ingrese usuario'"
            [label]="'Usuario *'" [id]="'usuario'" formControlName="usuario"
            [control]="formulario.get('usuario')"></app-lfsa-input>
        </div>
        <div class="form-group col-12 col-md-3">
          <app-lfsa-input [isReadOnly]="true" [type]="'text'" [class]="'letrasDanger'" [placeholder]="'Ingrese año'" [label]="'Año *'"
            [id]="'anio'" formControlName="anio" [control]="formulario.get('anio')"></app-lfsa-input>
        </div>
        <div class="form-group col-12 col-md-3">
          <app-lfsa-input [isReadOnly]="true" [type]="'text'" [class]="'letrasDanger'" [placeholder]="'Ingrese Código de vendedor'" [label]="'Código de vendedor *'"
            [id]="'codigoVendedor'" formControlName="codigoVendedor" [control]="formulario.get('codigoVendedor')"></app-lfsa-input>
        </div>
        <div class="form-group col-12 col-md-9">
          <app-lfsa-input [isReadOnly]="true" [type]="'text'" [class]="'letrasDanger'" [placeholder]="'Ingrese Nombre vendedor'" [label]="'Nombre de vendedor *'"
            [id]="'nombreVendedor'" formControlName="nombreVendedor" [control]="formulario.get('nombreVendedor')"></app-lfsa-input>
        </div>

        <div class="form-group col-12 col-md-4">
          <app-lfsa-input [isReadOnly]="true" [type]="'text'" [class]="'letrasDanger'" [placeholder]="'Ingrese Versión'" [label]="'Versión *'"
            [id]="'versionDescripcion'" formControlName="versionDescripcion" [control]="formulario.get('versionDescripcion')"></app-lfsa-input>
        </div>
        <div class="form-group col-12 col-md-4">
          <app-lfsa-input [type]="'text'" [class]="'letrasDanger'" [placeholder]="'Ingrese N# Marcas'" [label]="'N# Marcas *'"
            [id]="'nroMarcas'" formControlName="nroMarcas" [control]="formulario.get('nroMarcas')"></app-lfsa-input>
        </div>
        <div class="form-group col-12 col-md-4">
          <app-lfsa-input [type]="'text'" [class]="'letrasDanger'" [placeholder]="'Ingrese N# Facturas'" [label]="'N# Facturas *'"
            [id]="'nroFacturas'" formControlName="nroFacturas" [control]="formulario.get('nroFacturas')"></app-lfsa-input>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="form-group col-12 col-md-4"></div>
    <div class="form-group col-12 col-md-4">
      <button class="btn btn-success btn-block" [disabled]="formulario.invalid" (click)="actualizar()">
        <i class="fa fa-save"></i>
        Guardar</button>
    </div>
    <div class="form-group col-12 col-md-4"></div>
  </div>
</ng-template>